// Generated by Melange

import * as Buhta_cabinet__Link from "../../html/Link.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(currentRoute) {
  return function (kkm) {
    return function (contextRoute) {
      let tmp;
      let exit = 0;
      let kkmId;
      if (typeof currentRoute === "number") {
        tmp = "text-gray-medium";
      } else {
        switch (currentRoute.TAG | 0) {
          case /* Org */6 :
              const match = currentRoute._1;
              if (typeof match === "number" || match.TAG !== /* Kassa */2) {
                tmp = "text-gray-medium";
              } else {
                const match$1 = match._0._0;
                if (typeof match$1 === "number") {
                  tmp = "text-gray-medium";
                } else {
                  let tmp$1 = match$1._1;
                  if (typeof tmp$1 === "number" || tmp$1.TAG !== /* Receipts */1) {
                    tmp = "text-gray-medium";
                  } else {
                    kkmId = match$1._0;
                    exit = 1;
                  }
                }
              }
              break;
          case /* Admin */7 :
              const match$2 = currentRoute._0;
              if (typeof match$2 === "number" || match$2.TAG !== /* Orgs */1) {
                tmp = "text-gray-medium";
              } else {
                const match$3 = match$2._0;
                if (typeof match$3 === "number") {
                  tmp = "text-gray-medium";
                } else {
                  const match$4 = match$3._1;
                  if (typeof match$4 === "number" || match$4.TAG !== /* Kassa */2) {
                    tmp = "text-gray-medium";
                  } else {
                    const match$5 = match$4._0._0;
                    if (typeof match$5 === "number") {
                      tmp = "text-gray-medium";
                    } else {
                      let tmp$2 = match$5._1;
                      if (typeof tmp$2 === "number" || tmp$2.TAG !== /* Receipts */1) {
                        tmp = "text-gray-medium";
                      } else {
                        kkmId = match$5._0;
                        exit = 1;
                      }
                    }
                  }
                }
              }
              break;
          default:
            tmp = "text-gray-medium";
        }
      }
      if (exit === 1) {
        tmp = kkmId === kkm.id ? "text-white" : "text-gray-medium";
      }
      let tmp$3;
      let exit$1 = 0;
      let kkmId$1;
      if (typeof currentRoute === "number") {
        tmp$3 = "text-gray-medium";
      } else {
        switch (currentRoute.TAG | 0) {
          case /* Org */6 :
              const match$6 = currentRoute._1;
              if (typeof match$6 === "number" || match$6.TAG !== /* Kassa */2) {
                tmp$3 = "text-gray-medium";
              } else {
                const match$7 = match$6._0._0;
                if (typeof match$7 === "number") {
                  tmp$3 = "text-gray-medium";
                } else {
                  let tmp$4 = match$7._1;
                  if (typeof tmp$4 === "number" || tmp$4.TAG !== /* Journal */2) {
                    tmp$3 = "text-gray-medium";
                  } else {
                    kkmId$1 = match$7._0;
                    exit$1 = 1;
                  }
                }
              }
              break;
          case /* Admin */7 :
              const match$8 = currentRoute._0;
              if (typeof match$8 === "number" || match$8.TAG !== /* Orgs */1) {
                tmp$3 = "text-gray-medium";
              } else {
                const match$9 = match$8._0;
                if (typeof match$9 === "number") {
                  tmp$3 = "text-gray-medium";
                } else {
                  const match$10 = match$9._1;
                  if (typeof match$10 === "number" || match$10.TAG !== /* Kassa */2) {
                    tmp$3 = "text-gray-medium";
                  } else {
                    const match$11 = match$10._0._0;
                    if (typeof match$11 === "number") {
                      tmp$3 = "text-gray-medium";
                    } else {
                      let tmp$5 = match$11._1;
                      if (typeof tmp$5 === "number" || tmp$5.TAG !== /* Journal */2) {
                        tmp$3 = "text-gray-medium";
                      } else {
                        kkmId$1 = match$11._0;
                        exit$1 = 1;
                      }
                    }
                  }
                }
              }
              break;
          default:
            tmp$3 = "text-gray-medium";
        }
      }
      if (exit$1 === 1) {
        tmp$3 = kkmId$1 === kkm.id ? "text-white" : "text-gray-medium";
      }
      let tmp$6;
      let exit$2 = 0;
      let kkmId$2;
      if (typeof currentRoute === "number") {
        tmp$6 = "text-gray-medium";
      } else {
        switch (currentRoute.TAG | 0) {
          case /* Org */6 :
              const match$12 = currentRoute._1;
              if (typeof match$12 === "number" || match$12.TAG !== /* Kassa */2) {
                tmp$6 = "text-gray-medium";
              } else {
                const match$13 = match$12._0._0;
                if (typeof match$13 === "number") {
                  tmp$6 = "text-gray-medium";
                } else {
                  let tmp$7 = match$13._1;
                  if (typeof tmp$7 === "number" || tmp$7.TAG !== /* Settings */0) {
                    tmp$6 = "text-gray-medium";
                  } else {
                    kkmId$2 = match$13._0;
                    exit$2 = 1;
                  }
                }
              }
              break;
          case /* Admin */7 :
              const match$14 = currentRoute._0;
              if (typeof match$14 === "number" || match$14.TAG !== /* Orgs */1) {
                tmp$6 = "text-gray-medium";
              } else {
                const match$15 = match$14._0;
                if (typeof match$15 === "number") {
                  tmp$6 = "text-gray-medium";
                } else {
                  const match$16 = match$15._1;
                  if (typeof match$16 === "number" || match$16.TAG !== /* Kassa */2) {
                    tmp$6 = "text-gray-medium";
                  } else {
                    const match$17 = match$16._0._0;
                    if (typeof match$17 === "number") {
                      tmp$6 = "text-gray-medium";
                    } else {
                      let tmp$8 = match$17._1;
                      if (typeof tmp$8 === "number" || tmp$8.TAG !== /* Settings */0) {
                        tmp$6 = "text-gray-medium";
                      } else {
                        kkmId$2 = match$17._0;
                        exit$2 = 1;
                      }
                    }
                  }
                }
              }
              break;
          default:
            tmp$6 = "text-gray-medium";
        }
      }
      if (exit$2 === 1) {
        tmp$6 = kkmId$2 === kkm.id ? "text-white" : "text-gray-medium";
      }
      return JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                          route: Curry._1(contextRoute, {
                                TAG: /* Kassa */2,
                                _0: /* Kkms */{
                                  _0: /* Kkm */{
                                    _0: kkm.id,
                                    _1: /* View */3
                                  }
                                }
                              }),
                          children: JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                className: Caml_obj.caml_equal(currentRoute, Curry._1(contextRoute, {
                                          TAG: /* Kassa */2,
                                          _0: /* Kkms */{
                                            _0: /* Kkm */{
                                              _0: kkm.id,
                                              _1: /* View */3
                                            }
                                          }
                                        })) ? "text-white" : "text-gray-medium",
                                children: "Обзор"
                              })
                        }),
                    JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                          route: Curry._1(contextRoute, {
                                TAG: /* Kassa */2,
                                _0: /* Kkms */{
                                  _0: /* Kkm */{
                                    _0: kkm.id,
                                    _1: {
                                      TAG: /* Receipts */1,
                                      _0: /* List */0
                                    }
                                  }
                                }
                              }),
                          children: JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                className: tmp,
                                children: "Чеки"
                              })
                        }),
                    JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                          route: Curry._1(contextRoute, {
                                TAG: /* Kassa */2,
                                _0: /* Kkms */{
                                  _0: /* Kkm */{
                                    _0: kkm.id,
                                    _1: {
                                      TAG: /* Journal */2,
                                      _0: /* Logs */0
                                    }
                                  }
                                }
                              }),
                          children: JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                className: tmp$3,
                                children: "Журнал"
                              })
                        }),
                    JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                          route: Curry._1(contextRoute, {
                                TAG: /* Kassa */2,
                                _0: /* Kkms */{
                                  _0: /* Kkm */{
                                    _0: kkm.id,
                                    _1: {
                                      TAG: /* Settings */0,
                                      _0: /* General */0
                                    }
                                  }
                                }
                              }),
                          children: JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                className: tmp$6,
                                children: "Настройки"
                              })
                        })
                  ],
                  className: "flex justify-between bg-black px-4 py-3"
                });
    };
  };
}

function KassaSubheader(Props) {
  return Curry._1(make(Props.currentRoute)(Props.kkm), Props.contextRoute);
}

const make$1 = KassaSubheader;

export {
  make$1 as make,
}
/* Buhta_cabinet__Link Not a pure module */
